export const reflectable = Symbol("reflectable");
export const resettable = Symbol("resettable");
export const slottable = Symbol("slottable");
export const validatable = Symbol("validatable");
